import React from 'react';
import styles from './ccf-acd-header.module.scss';
import { Badge, Divider, Popover } from '@mui/material';
import {
  CcfBox,
  CcfTypography,
  CcfAcdNewNotificationIcon,
  CcfAcdLogoutIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { loginActions } from '../login/+state/login.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectVoicePrefCheckboxState,
  voicePreferenceActions,
} from '../ccf-voice-preference/agentSessionSlice';
import { globalActions, getConversationMessage } from '../global.app.slice';
import {
  ccfConversationsActions,
  getAgents,
} from '../ccf-mocks/ccf-app-agent-messages/+state/ccf-conversations.slice';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isEternalsEnv } from '../../util/common';
import { Navigation } from '../../enums/navigation-menus';

/* eslint-disable-next-line */
export interface CcfAcdHeaderPopoverProps {
  anchorEl?: any;
  currentContact?: any;
  handleClose?: any;
  hideMediaControlClicked?: any;
  popoverFeature?: any;
  conversationReplyMessage?: any;
  onNotificationRead?: () => void;
}

/**
 * Component displays App header popover on clicking on header icons
 * @param props -CcfAcdHeaderPopoverProps
 * @returns app header component for landing screen
 * @example <CcfAcdHeaderPopover/>
 */
export function CcfAcdHeaderPopover(props: CcfAcdHeaderPopoverProps) {
  const { logOutUser } = loginActions;
  const { resetVoicePrefState } = voicePreferenceActions;
  const { setredirectToDashboardOnLogout } = voicePreferenceActions;
  const voicePrefernceRememberOption = useSelector(
    selectVoicePrefCheckboxState
  );
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const { setAuthenticationStage } = globalActions;
  const conversationMessage = useSelector(getConversationMessage);
  const agents = useSelector(getAgents);
  const { updateSelectedAgent } = ccfConversationsActions;

  /**@example */
  const navigateToMessages = () => {
    // Find the Supervisor agent in Redux state and select it
    const supervisorAgent = agents?.find((a: any) => a.name === 'Supervisor');
    if (supervisorAgent) {
      dispatch(
        updateSelectedAgent({ agent: supervisorAgent, type: 'favourite' })
      );
    }
    // Mark the notification as read — resets badge count and removes the entry
    props.onNotificationRead?.();
    setTimeout(() => {
      dispatch(
        globalActions.setSelectedMenu({ name: Navigation.AGENT_MESSAGES })
      );
      props.handleClose?.();
    }, 0);
  };

  const notificationdata = [
    ...(props.conversationReplyMessage
      ? [
          {
            heading: 'Supervisor Message',
            subHeading: 'You have received a message from Supervisor',
            timer: conversationMessage?.timestamp
              ? new Date(conversationMessage.timestamp).toLocaleString(
                  'en-GB',
                  {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  }
                )
              : 'Just Now',
            newNotification: true,
            onClick: navigateToMessages,
          },
        ]
      : []),
    {
      heading: 'Password Expiration',
      subHeading: 'Your password will expire in 9 days',
      timer: 'Just Now',
      newNotification: true,
    },
    {
      heading: 'Email Address Verfied',
      subHeading: 'You have sucessfully verfied your email address',
      timer: 'Just Now',
      newNotification: true,
    },
    {
      heading: 'New time off request',
      subHeading: 'Ryan johnson',
      timer: 'April 17,2020 2:22 PM',
      newNotification: false,
    },
    {
      heading: 'Time off request cancelled',
      subHeading: 'Sammy Davis',
      timer: 'April 15,2020 3:45 PM',
      newNotification: false,
    },
  ];

  /**
   * Function to handle icon for status
   * @param status - string
   * @example handleIconForStatus()
   * @returns
   */
  const signOutUser = () => {
    if (isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri: '/',
      });
      if (!isEternalsEnv()) {
        dispatch(setAuthenticationStage(1));
      }
    } else {
      dispatch(logOutUser(false));
      dispatch(setredirectToDashboardOnLogout());
      if (!voicePrefernceRememberOption.checkboxVal) {
        dispatch(resetVoicePrefState());
      }
    }
  };
  return (
    <Popover
      id={'voicemail-outbound-popover'}
      style={{
        marginTop: '40px',
      }}
      open={Boolean(props?.anchorEl)}
      keepMounted
      anchorEl={props?.anchorEl}
      onClose={props?.handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {props?.popoverFeature === 'Notification' ? (
        <CcfBox className={styles.notificationPopupContainer}>
          <CcfBox className={styles.headerSection}>
            <CcfTypography className={styles.txtNotifications}>
              Notifications
            </CcfTypography>
            {props?.conversationReplyMessage && (
              <CcfBox className={styles.badge}>1</CcfBox>
            )}
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox className={styles.notificationScrollContainer}>
            {notificationdata.map((notification: any) => {
              return (
                <div
                  className={`${styles.notificationCard} ${
                    notification.newNotification ? styles.unread : ''
                  }`}
                  onClick={notification.onClick}
                  style={
                    notification.onClick ? { cursor: 'pointer' } : undefined
                  }
                >
                  <CcfBox className={styles.notificationCardHeader}>
                    <CcfTypography className={styles.notificationHeading}>
                      {notification.heading}
                    </CcfTypography>
                    {notification.newNotification && (
                      <CcfAcdNewNotificationIcon
                        className={styles.newNotificationIcon}
                      />
                    )}
                  </CcfBox>
                  <CcfTypography className={styles.notificationSubHeading}>
                    {notification.subHeading}
                  </CcfTypography>
                  <CcfTypography className={styles.notificationTimer}>
                    {notification.timer}
                  </CcfTypography>

                  {/* <Divider
                    style={{ height: '1px', width: '100%', marginTop: '16px' }}
                  /> */}
                </div>
              );
            })}
          </CcfBox>
        </CcfBox>
      ) : props?.popoverFeature === 'Dashboard' ? (
        <CcfBox className={styles.FavouritePopupContainer}>
          <CcfBox className={styles.favouriteHeaderSection}>
            <CcfTypography className={styles.headerTitle}>
              Favourite Dashboard
            </CcfTypography>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox
            marginTop={'5px'}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            {' '}
            <CcfBox className={styles.favBtnContainer}>
              <CcfBox style={{ width: '100%', padding: '16px' }}>
                <CcfTypography className={styles.favListText}>
                  My Stats
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  My Team Stats
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  Contact Center Dashboard
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  Supervisor Overview
                </CcfTypography>
              </CcfBox>
            </CcfBox>
          </CcfBox>
        </CcfBox>
      ) : (
        <CcfBox className={styles.signoutPopupContainer}>
          <CcfBox className={styles.signoutContainer}>
            <CcfBox style={{ width: '100%' }}>
              <CcfTypography
                className={styles.scheduleTxt}
                style={{ paddingBottom: '18px' }}
              >
                {translate('schedule')}
              </CcfTypography>
              <CcfTypography className={styles.scheduleTxt}>
                {translate('changePassword')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox marginTop={'10px'}></CcfBox>

          <CcfBox className={styles.signoutContainer}>
            <CcfBox style={{ width: '100%' }}>
              <CcfTypography
                className={styles.scheduleTxt}
                style={{ paddingBottom: '18px' }}
              >
                {translate('supportDownloads')}
              </CcfTypography>
              <CcfTypography className={styles.scheduleTxt}>
                {translate('contactus')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox className={styles.signOutBtnContainer}>
            <CcfBox
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
              }}
              onClick={signOutUser}
            >
              <CcfAcdLogoutIcon style={{ fontSize: '16px' }} />
              <CcfTypography className={styles.scheduleTxt}>
                {translate('logOut')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
        </CcfBox>
      )}
    </Popover>
  );
}

export default CcfAcdHeaderPopover;
